<template>
    <div>
        <div class="flex flex-row" >
            <div class="flex flex-row align-items-center mb-2 mr-4">
                <div class="flex flex-row w-9rem">
                    <div>lengthHigh</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Период для определения максимума цены. Чем больше число, тем чаще будут идти сигналы на покупку, но тем больше будет ложных сигналов, на плавном снижении цены.'"></i></div>
                </div>
                <InputText type="text" v-model="value.lengthHigh" class="w-5rem p-1 mb-1" />
            </div>
            <div class="flex flex-row align-items-center mb-2">
                <div class="flex flex-row w-8rem">
                    <div>lengthLow</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Период для определения минимума цены'"></i></div>
                </div>
                <InputText type="text" v-model="value.lengthLow" class="w-5rem p-1 mb-1" />
            </div>
        </div>
    </div>
</template>

<script>
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";

export default {
    components: {InputText, Dropdown},
    props:{
        value: Object,
    },
    data(){
        return {

        }
    },
    mounted(){
        this.form = this.value;
    },
}
</script>
